import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Table } from 'semantic-ui-react';

// Global Types
import { AppState } from 'services/types';

// Components
import EventsTimelineHeadCell from './components/EventsTimelineHeadCell';

// Selectors
// @ts-ignore
import { selectDatesOfTheWeek } from '../../selectors';

// Styles
import './styles.scss';

interface ConnectedProps {
    datesOfTheWeek?: string[];
}

type Props = ConnectedProps;

export class EventsTimelineHeadComponent extends React.PureComponent<Props> {
    render(): React.ReactElement {
        const { datesOfTheWeek } = this.props;

        return (
            <Table.Header>
                <Table.Row>
                    <Table.HeaderCell
                        textAlign="center"
                        className="EventsTimelineHead"
                    >
                        GROUP
                    </Table.HeaderCell>
                    {datesOfTheWeek &&
                        datesOfTheWeek.map((date) => (
                            <EventsTimelineHeadCell key={date} date={date} />
                        ))}
                </Table.Row>
            </Table.Header>
        );
    }
}

const mapStateToProps = createStructuredSelector<AppState, {}, ConnectedProps>({
    datesOfTheWeek: selectDatesOfTheWeek
});

export default connect(mapStateToProps)(EventsTimelineHeadComponent);
